import type React from 'react'
import Link from 'next/link'

import { OrderCard } from '@/components/molecules/orders'

interface OrdersListProps extends React.ComponentPropsWithoutRef<'div'> {
  data: any[]
}

export const OrdersList = ({ data }: OrdersListProps) => {
  return (
    <div className="flex w-full flex-col gap-1.5 p-1">
      {data?.map((order) => {
        const { id, cart } = order || {}

        // if (!cart)
        //   return (
        //     <Link href={`/orders/${id}`} key={id} prefetch={true}>
        //       <OrderCard order={order} />
        //     </Link>
        //   )

        return <OrderCard order={order} key={id} />
      })}
    </div>
  )
}
